import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#top", label: "Home" },
  { href: "#equipment", label: "Equipment" },
  { href: "#why-us", label: "Why Us" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

export default function Navbar({ onBookClick }) {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-border"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <img
            src="https://customer-assets.emergentagent.com/job_hire-showcase/artifacts/tllvl69e_IMG_0034.PNG"
            alt="MRL Plant Hire"
            className="h-12 w-12 object-contain bg-secondary p-0.5"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-heading uppercase text-base tracking-tight">
              MRL Plant Hire
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              Warragamba · NSW
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-heading uppercase text-sm tracking-wider text-secondary hover:text-orange-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:+61475591917"
            data-testid="navbar-call-link"
            className="text-sm font-medium text-secondary hover:text-orange-600 inline-flex items-center gap-1.5"
          >
            <Phone className="w-4 h-4" /> 0475 591 917
          </a>
          <Button
            data-testid="navbar-book-btn"
            onClick={onBookClick}
            className="btn-sharp bg-orange-500 hover:bg-orange-600 text-white font-heading uppercase tracking-wider"
          >
            Get a Quote
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-border bg-white">
          <div className="px-6 py-4 grid gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="font-heading uppercase text-sm"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="mobile-book-btn"
              onClick={() => {
                setOpen(false);
                onBookClick();
              }}
              className="btn-sharp bg-orange-500 hover:bg-orange-600 text-white font-heading uppercase tracking-wider"
            >
              Get a Quote
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
